const DINO_ASSISTANT_OPEN_EVENT = "dino:assistant-open";

interface DinoAssistantOpenDetail {
    /** Optional rounded surface that Dino should help with first. */
    readingTarget?: HTMLElement;
    /** Short, sanitized label displayed in the assistant context chip. */
    contextLabel?: string;
    /** Releases the temporary surface contribution from the context topic. */
    releaseContext?: () => void;
}

/** Opens the assistant without coupling callers to its React tree. */
function openDinoAssistant(detail: DinoAssistantOpenDetail = {}): void {
    if (typeof window === "undefined") {
        return;
    }

    window.dispatchEvent(new CustomEvent<DinoAssistantOpenDetail>(
        DINO_ASSISTANT_OPEN_EVENT,
        { detail }
    ));
}

export { DINO_ASSISTANT_OPEN_EVENT, openDinoAssistant };
export type { DinoAssistantOpenDetail };
